import { render, staticRenderFns } from "./curveList.vue?vue&type=template&id=448a6982&scoped=true"
import script from "./curveList.vue?vue&type=script&lang=js"
export * from "./curveList.vue?vue&type=script&lang=js"
import style0 from "./curveList.vue?vue&type=style&index=0&id=448a6982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a6982",
  null
  
)

export default component.exports